import { Gitlab, GitPullRequest } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
// Import the manifest module directly — never `../index.js`, whose plugin
// definition pulls the server graph (Drizzle, Fastify) into the Vite bundle.
import { gitlabWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  gitlabWeb,
  {
    GitLabSettingsPage: () => import('./GitLabSettingsPage'),
    GitLabMrContextProvider: () => import('./GitLabMrContextProvider'),
    GitLabMrLinkBadge: () => import('./GitLabMrLinkBadge'),
    GitLabMrMentionBadge: () => import('./GitLabMrMentionBadge'),
  },
  {
    icons: { Gitlab, GitPullRequest },
  },
);
